(function(){try{if(typeof document<`u`){var e=document.createElement(`style`);e.appendChild(document.createTextNode(`._errorWrapper_171rr_1{word-break:break-word}._copyIcon_171rr_5{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1lmim_1{margin-bottom:var(--dixa-size-spacer-300)}._wrapperBox_1lmim_4{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._wrapperBoxErrorBorder_1lmim_9{border-color:var(--dixa-typography-color-error)}/*$vite$:1*/`)),document.head.appendChild(e)}}catch(e){console.error(`vite-plugin-css-injected-by-js`,e)}})();
import { gql as e, isApolloError as t, useApolloClient as n, useLazyQuery as r, useMutation as i, useQuery as a } from "@apollo/client";
import { getOperationName as o } from "@apollo/client/utilities";
import { Badge as s, Banner as c, Button as l, FieldText as u, FieldWrapper as d, FlexBox as f, FormField as p, Icon as m, List as h, Modal as g, ModalBody as _, ModalFoot as v, ModalHead as y, Spinner as b, Tag as x, Text as S, Tooltip as ee } from "@dixa/lib-shared-habla";
import { colors as C } from "@dixa/lib-shared-tokens";
import { createContext as w, createElement as T, useCallback as E, useContext as D, useEffect as O, useState as k } from "react";
import { Fragment as A, jsx as j, jsxs as M } from "react/jsx-runtime";
import { FormProvider as N, useController as te } from "react-hook-form";
import ne from "moment";
import { useInterval as re } from "react-use";
import ie from "lodash/lowerCase";
import P from "lodash/upperFirst";
import { MockedProvider as ae } from "@apollo/client/testing";
import { render as oe } from "@testing-library/react";
import { HookFormText as F } from "lib-shared-hook-form";
import se from "classnames";
//#region src/apis/widgetConfiguration/queries/widgetConfiguration.query.ts
var I = e`
  query getWidgetConfiguration($id: ID!) {
    Management {
      widgetConfigurations(id: $id) {
        id
        type
        enabled
        name
        misconfigured
        misconfigurationCause
        additionalProperties
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`, L = e`
  mutation updateWidgetConfiguration(
    $id: ID!
    $enabled: Boolean
    $name: String!
    $settings: [Management_SettingInput!]
    $renderConditions: [Management_JSONObject!]
  ) {
    Management {
      updateWidgetConfiguration(
        id: $id
        enabled: $enabled
        name: $name
        settings: $settings
        renderConditions: $renderConditions
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`, R = e`
  mutation createWidgetConfiguration(
    $type: String!
    $enabled: Boolean!
    $name: String!
    $settings: [Management_SettingInput!]!
    $renderConditions: [Management_JSONObject!]!
  ) {
    Management {
      createWidgetConfiguration(
        type: $type
        enabled: $enabled
        name: $name
        settings: $settings
        renderConditions: $renderConditions
      ) {
        id
        name
        enabled
        misconfigured
        misconfigurationCause
        additionalProperties
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`, z = e`
  mutation deleteWidgetConfiguration($id: ID!) {
    Management {
      deleteWidgetConfiguration(id: $id) {
        id
      }
    }
  }
`, ce = (e, t) => function(n, r) {
	return a(n, {
		...r,
		context: {
			operationName: o(n),
			...r?.context,
			widgetId: e,
			widgetType: t
		}
	});
}, B = (e, t) => function(n, i) {
	return r(n, {
		...i,
		context: {
			operationName: o(n),
			...i?.context,
			widgetId: e,
			widgetType: t
		}
	});
}, le = (e, t, n) => function(r, i) {
	return n.query({
		query: r,
		variables: i,
		context: {
			operationName: o(r),
			widgetId: e,
			widgetType: t
		}
	});
}, ue = (e, t) => function(n, r) {
	return i(n, {
		...r,
		context: {
			operationName: o(n),
			...r?.context,
			widgetId: e,
			widgetType: t
		}
	});
}, V = ({ error: e }) => e.extensions?.integration?.code === "DIXA_HEADER_CHECK_ERROR", de = ({ errors: e }) => e.some((e) => V({ error: e })), H = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_AUTHORIZATION_ERROR", fe = ({ errors: e }) => e.some((e) => H({ error: e })), U = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_PERMISSION_ERROR", pe = ({ errors: e }) => e.some((e) => U({ error: e })), W = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_SERVICE_UNAVAILABLE_ERROR", me = ({ errors: e }) => e.some((e) => W({ error: e })), G = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_NOT_FOUND_ERROR", he = ({ errors: e }) => e.some((e) => G({ error: e })), ge = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_CONFLICT_ERROR", _e = ({ errors: e }) => e.some((e) => ge({ error: e })), ve = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_BAD_REQUEST_ERROR", ye = ({ errors: e }) => e.some((e) => ve({ error: e })), be = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_FORBIDDEN_ERROR", xe = ({ errors: e }) => e.some((e) => be({ error: e })), Se = ({ error: e }) => e.extensions?.integration?.code === "DOWNSTREAM_API_TOO_MANY_REQUESTS_ERROR", Ce = ({ errors: e }) => e.some((e) => Se({ error: e })), we = ({ error: e }) => e.extensions?.integration?.code === "WIDGET_MISCONFIGURED_ERROR", Te = ({ errors: e }) => e.some((e) => we({ error: e })), K = (e) => {
	let { delay: t = 2e3 } = e || {}, [n, r] = k(!1);
	return O(() => {
		let e = n ? window.setTimeout(() => r(!1), t) : void 0;
		return () => window.clearTimeout(e);
	}, [t, n]), {
		isCopied: n,
		copy: (e) => {
			navigator.clipboard.writeText(e), r(!0);
		}
	};
}, q = {
	errorWrapper: "_errorWrapper_171rr_1",
	copyIcon: "_copyIcon_171rr_5"
}, Ee = ({ error: e, retry: n, isMisconfigured: r = !1, hideCopyButton: i = !1 }) => {
	let a = e && t(e) && e?.graphQLErrors?.length > 0, { isCopied: o, copy: s } = K(), u = /* @__PURE__ */ j(m, {
		color: C.red[500],
		size: 16,
		name: "exclamation-triangle-filled"
	});
	if (r || a && Te({ errors: e.graphQLErrors })) return /* @__PURE__ */ M(f, {
		margin: "0 0 100",
		padding: "200",
		className: q.errorWrapper,
		children: [/* @__PURE__ */ j(f, {
			margin: "0 300 0 0",
			alignItems: "center",
			children: u
		}), /* @__PURE__ */ j(S.Paragraph, {
			color: "secondary",
			children: "This integration is not properly configured and could not be loaded. Please contact your administrator."
		})]
	});
	if (!a) return /* @__PURE__ */ j(f, {
		margin: "200 0",
		flexDirection: "column",
		children: /* @__PURE__ */ j(h.Item, {
			contentLeft: u,
			title: "Something went wrong. Please try again later.",
			variant: "dense"
		})
	});
	let d = e?.graphQLErrors || [];
	return /* @__PURE__ */ M(f, {
		margin: "200 0 300",
		flexDirection: "column",
		className: q.errorWrapper,
		children: [d.map((t, n) => {
			let r = t?.extensions?.integration, i = r?.message || e?.message || "No error message available", a = r?.responseBody && JSON.parse(r?.responseBody), o = a?.errorMessages || [], s = a?.warningMessages || [], c = [...o, ...s].join(" ");
			return /* @__PURE__ */ j(h.Item, {
				title: i,
				titleSecondary: c,
				contentLeft: u
			}, n);
		}), !i && /* @__PURE__ */ M(f, {
			margin: "200 0 300",
			flexDirection: "column",
			gap: "200",
			children: [/* @__PURE__ */ j(c, {
				variant: "info",
				description: /* @__PURE__ */ j(S.Paragraph, {
					variant: "4",
					children: "Please copy the error details by clicking on the button below and include them in your support request."
				})
			}), /* @__PURE__ */ M(f, {
				flexDirection: "row",
				gap: "200",
				justifyContent: "space-between",
				children: [n && /* @__PURE__ */ j(l, {
					variant: "secondary",
					icon: "sync",
					onClick: () => n(),
					children: "Retry"
				}), /* @__PURE__ */ j(l, {
					variant: "secondary",
					icon: o ? "done" : "copy",
					onClick: () => s(JSON.stringify(d, null, 2)),
					className: q.copyIcon,
					children: "Copy error payload"
				})]
			})]
		})]
	});
}, De = ({ headline: e, text: t, children: n, onConfirm: r, onCancel: i, confirmLabel: a, cancelLabel: o = "Cancel", confirmVariant: s = "primary", cancelVariant: c = "secondary", isOpen: l, setIsOpen: u, showOnClose: d = !1 }) => /* @__PURE__ */ M(g, {
	isOpen: l,
	onClose: () => {
		i && i(), u(!1);
	},
	children: [
		/* @__PURE__ */ j(y, {
			title: e,
			onClose: d ? i : void 0
		}),
		/* @__PURE__ */ M(_, { children: [t && /* @__PURE__ */ j("div", {
			style: { width: "600px" },
			children: t
		}), n] }),
		/* @__PURE__ */ j(v, {
			confirmOnClick: r ? () => {
				r(), u(!1);
			} : void 0,
			cancelOnClick: () => {
				i && i(), u(!1);
			},
			confirmName: a,
			cancelName: o,
			confirmProps: { variant: s },
			cancelProps: { variant: c }
		})
	]
}), Oe = "The configuration of the integration is not correct. Please check the settings.", ke = ({ cause: e }) => /* @__PURE__ */ j(f, {
	margin: "0 0 400",
	children: /* @__PURE__ */ j(c, {
		variant: "fail",
		headline: "This integration is misconfigured",
		description: /* @__PURE__ */ M(f, {
			gap: "300",
			flexDirection: "column",
			children: [/* @__PURE__ */ j(S.Paragraph, { children: e || "The configuration of the integration is not correct. Please check the settings." }), /* @__PURE__ */ M(f, {
				flexDirection: "column",
				gap: "100",
				children: [/* @__PURE__ */ j(S.Heading, {
					variant: "heading-3",
					children: "Additional information"
				}), /* @__PURE__ */ j(S.Paragraph, { children: "While the integration is in a misconfigured state, its content is not shown in the sidebar. Instead, we show a message that hints the agent to get in touch with the administrator." })]
			})]
		})
	})
}), Ae = ({ form: e, integrationId: t, onValidSubmit: n, error: r, onRetry: i, isLoading: a, isWidgetUnknown: o, children: s }) => r ? /* @__PURE__ */ j(Ee, {
	error: r,
	retry: i
}) : a ? /* @__PURE__ */ j(b, { "data-testid": "widget-settings-loading" }) : o ? /* @__PURE__ */ M(S.Paragraph, { children: [
	"A widget with the id ",
	/* @__PURE__ */ j(x, { children: t }),
	" does not exist."
] }) : /* @__PURE__ */ j(N, {
	...e,
	children: /* @__PURE__ */ j("form", {
		noValidate: !0,
		tabIndex: -1,
		"data-testid": `widget-settings-form-${t ?? "create-new"}`,
		onSubmit: e.handleSubmit(n),
		children: s
	})
}), je = ne, Me = ie, Ne = P;
//#endregion
//#region src/utils/common.ts
function Pe(e, t = !0) {
	try {
		return JSON.parse(JSON.stringify(e));
	} catch {
		return t && console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
	}
}
var Fe = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, Ie = (e) => {
	let t = Me(e);
	return t.length === 0 ? e : Ne(t);
}, Le = "DD MMM YYYY @ HH:mm";
function Re(e, t) {
	return e == null ? t : typeof e == "boolean" ? e : e === "true";
}
function ze(e, t) {
	return e == null ? t : String(e);
}
//#endregion
//#region src/utils/countryCodes.ts
function Be(e) {
	try {
		return new Intl.DisplayNames(["en"], { type: "region" }).of(e.toUpperCase()) ?? e;
	} catch {
		return e;
	}
}
var Ve = /* @__PURE__ */ "AF.AX.AL.DZ.AD.AO.AI.AG.AR.AM.AW.AC.AU.AT.AZ.BS.BH.BD.BB.BY.BE.BZ.BJ.BM.BT.BO.BA.BW.BV.BR.IO.BN.BG.BF.BI.KH.CA.CV.BQ.KY.CF.TD.CL.CN.CX.CC.CO.KM.CG.CD.CK.CR.HR.CU.CW.CY.CZ.CI.DK.DJ.DM.DO.EC.EG.SV.GQ.ER.EE.SZ.ET.FK.FO.FJ.FI.FR.GF.PF.TF.GA.GM.GE.DE.GH.GI.GR.GL.GD.GP.GT.GG.GN.GW.GY.HT.HM.VA.HN.HK.HU.IS.IN.ID.IR.IQ.IE.IM.IL.IT.JM.JP.JE.JO.KZ.KE.KI.KP.XK.KW.KG.LA.LV.LB.LS.LR.LY.LI.LT.LU.MO.MG.MW.MY.MV.ML.MT.MQ.MR.MU.YT.MX.MD.MC.MN.ME.MS.MA.MZ.MM.NA.NR.NP.NL.AN.NC.NZ.NI.NE.NG.NU.NF.MK.NO.OM.PK.PS.PA.PG.PY.PE.PH.PN.PL.PT.QA.CM.RE.RO.RU.RW.BL.SH.KN.LC.MF.PM.WS.SM.ST.SA.SN.RS.SC.SL.SG.SX.SK.SI.SB.SO.ZA.GS.KR.SS.ES.LK.VC.SD.SR.SJ.SE.CH.SY.TW.TJ.TZ.TH.TL.TG.TK.TO.TT.TA.TN.TR.TM.TC.TV.UG.UA.AE.GB.US.UM.UY.UZ.VU.VE.VN.VG.WF.EH.YE.ZM.ZW.ZZ".split("."), He = (e) => {
	if (!e?.trim()) return "Please add a valid subdomain";
	let t = ["https://", "http://"].find((t) => e.startsWith(t)), n = t ? `Please remove the protocol \`${t}\` from the hostname` : "", r = e.endsWith("/") ? "Please remove the trailing `/` from the hostname" : "";
	if (!t && e.includes("@")) return "Please remove the `@` from the hostname";
	if (/\s/.test(e)) return "Please remove the spaces from the hostname";
	if (n && r) return `Please remove the protocol \`${t}\` and the trailing \`/\` from the hostname`;
	if (n) return n;
	if (r) return r;
};
//#endregion
//#region src/utils/jwt.ts
function Ue(e) {
	let t = e.split(".")[1];
	if (!t) throw Error("Invalid token");
	let n = t.replace(/-/g, "+").replace(/_/g, "/");
	try {
		return JSON.parse(atob(n).toString());
	} catch (e) {
		throw Error(`Failed to parse the JSON Web Token with the following error: ${e}`);
	}
}
//#endregion
//#region ../../shared/types-api/src/elevion/types/elevionConstants.ts
var J = ["==", "!="], We = [...J], Ge = [
	...J,
	"begins_with",
	"ends_with",
	"matches"
], Ke = [
	"contains_one",
	"contains_all",
	"is_empty"
], qe = ["between", "not_between"], Je = [
	...J,
	">",
	"<"
], Ye = [
	"before",
	"after",
	...Je
], Xe = Ye;
[.../* @__PURE__ */ new Set([
	...We,
	...Ge,
	...Ke,
	...qe,
	...Ye,
	...Xe,
	...Je
])];
var Ze = /* @__PURE__ */ function(e) {
	return e.Queue = "system__queue", e.Tags = "system__tags", e;
}({}), Qe = (e) => e === Ze.Queue ? "Queue" : e === Ze.Tags ? "Tags" : e.startsWith("custom__") ? "Custom attribute" : e, $e = (e, t) => {
	if ("logicalOp" in e) {
		e.nodes.forEach((e) => $e(e, t));
		return;
	}
	t.add(Qe(e.field));
}, et = (e) => {
	let t = /* @__PURE__ */ new Set();
	return e.forEach((e) => $e(e, t)), [...t].sort().join(", ");
}, Y = (e, t, n, r) => {
	let i = n.length > 0, a = et(n);
	if (t) {
		i && e("settings:condition:created", { conditionType: a });
		return;
	}
	i ? e("settings:condition:updated", { conditionType: a }) : r && e("settings:condition:deleted", {});
}, X = w(null);
function tt() {
	let e = D(X);
	if (e === null) throw Error("useInboundOAuthContext requires InboundOAuthContext to be used higher up in the component tree, below InboundOAuthContext.Provider");
	return e;
}
//#endregion
//#region src/hooks/useInboundOAuthContext/useInboundOAuthContext.utils.test.ts
function nt() {
	return {
		isInboundOAuth: !1,
		setIsInboundOAuth: () => {},
		hasTriggeredAuthorization: !1,
		setHasTriggeredAuthorization: () => {}
	};
}
//#endregion
//#region src/hooks/useWidgetContext/useWidgetContext.ts
var rt = w(null), it = rt.Provider;
function at() {
	let e = D(rt);
	if (e === null) throw Error("useWidgetContext requires WidgetContext to be used higher up in the component tree, below WidgetContextProvider");
	return e;
}
//#endregion
//#region src/utils/testing.ts
function ot() {
	window._partner = { events: { emit: () => {} } };
}
var st = {
	useMutation: i,
	useQuery: () => ({
		data: void 0,
		loading: !1,
		error: void 0
	}),
	useLazyQuery: () => [() => {}, { loading: !1 }],
	executeQuery: () => {},
	showNotification: () => {},
	showModal: () => {}
}, ct = { baseUrl: "http://localhost/graphql" };
function lt(e, { mocks: t = [], overrides: n = {} } = {}) {
	let r = vi.fn(), i = vi.fn(), a = {
		configuration: ct,
		handleRedirect: r,
		showNotification: i,
		...n
	};
	return {
		...oe(T(ae, { mocks: t }, T(X.Provider, { value: nt() }, T(it, { value: st }, T(e, a))))),
		handleRedirect: r,
		showNotification: i
	};
}
function ut({ id: e, configuration: t }) {
	let n = t?.settings ?? [];
	return {
		request: {
			query: I,
			variables: { id: e }
		},
		result: { data: { Management: { widgetConfigurations: [{
			id: e,
			type: t?.type ?? "UNKNOWN",
			name: t?.name ?? "Test widget",
			enabled: t?.enabled ?? !0,
			misconfigured: t?.misconfigured ?? !1,
			misconfigurationCause: t?.misconfigurationCause ?? null,
			additionalProperties: t?.additionalProperties ?? null,
			renderConditions: t?.renderConditions ?? [],
			settings: n
		}] } } }
	};
}
function dt({ variables: e, result: t }) {
	let n = {
		...e,
		renderConditions: e.renderConditions ?? []
	};
	return {
		request: {
			query: R,
			variables: n
		},
		result: { data: { Management: { createWidgetConfiguration: {
			id: t?.id ?? "new-id",
			name: t?.name ?? e.name,
			enabled: t?.enabled ?? e.enabled,
			misconfigured: t?.misconfigured ?? !1,
			misconfigurationCause: t?.misconfigurationCause ?? null,
			additionalProperties: t?.additionalProperties ?? null,
			renderConditions: t?.renderConditions ?? n.renderConditions,
			settings: t?.settings ?? []
		} } } }
	};
}
function ft({ variables: e, result: t }) {
	return {
		request: {
			query: L,
			variables: e
		},
		result: { data: { Management: { updateWidgetConfiguration: {
			id: e.id,
			name: t?.name ?? e.name,
			enabled: t?.enabled ?? e.enabled ?? !0,
			misconfigured: t?.misconfigured ?? !1,
			misconfigurationCause: t?.misconfigurationCause ?? null,
			additionalProperties: t?.additionalProperties ?? null,
			renderConditions: t?.renderConditions ?? e.renderConditions ?? [],
			settings: t?.settings ?? []
		} } } }
	};
}
function pt({ id: e }) {
	return {
		request: {
			query: z,
			variables: { id: e }
		},
		result: { data: { Management: { deleteWidgetConfiguration: { id: e } } } }
	};
}
//#endregion
//#region src/utils/widgetSettingsConversion/widgetSettingsConversion.ts
function mt(e, t) {
	let n = {};
	for (let r of t) {
		let t = e.find((e) => e.key === r.key)?.value;
		r.secret && t === void 0 || (r.type === "boolean" ? n[r.key] = Re(t, r.defaultValue) : n[r.key] = ze(t, r.defaultValue));
	}
	return n;
}
function ht(e, t) {
	return t.filter((t) => e[t.key] !== void 0).map((t) => ({
		key: t.key,
		value: String(e[t.key]),
		secret: t.secret
	}));
}
//#endregion
//#region src/utils/widgetSettingsConversion/widgetSettingsConversion.utils.ts
function gt(e) {
	return Object.fromEntries(e.map((e) => [e.key, e.label]));
}
async function _t(e, { fieldDefinitions: t, isCreationMode: n, create: r, update: i, renderConditions: a }) {
	let o = ht(e, t), s = {
		name: e.name,
		enabled: e.enabled,
		settings: o,
		...a !== void 0 && { renderConditions: a }
	};
	n ? await r(s) : await i(s);
}
//#endregion
//#region src/helpers/dev-helper.ts
function vt(e) {
	let { user_id: t, iss: n } = Ue(e);
	return {
		"x-integration-user-id": t,
		"x-integration-organization-id": n
	};
}
function yt(e) {
	return e.startsWith("http://localhost");
}
//#endregion
//#region src/hooks/useTracking/useTracking.ts
function Z() {
	return { track: (e, t) => window._partner.events.emit(e, t) };
}
//#endregion
//#region src/components/oAuth/oAuthSettings.tsx
var bt = (e) => {
	switch (e) {
		case "CONNECTED": return {
			icon: "check-circle-filled",
			color: C.green[500],
			tooltip: "Connected"
		};
		case "CONNECTING": return {
			icon: "sync",
			color: C.neutral[500],
			tooltip: "Connecting.."
		};
		case "CONNECTION_FAILED": return {
			icon: "close-circle-filled",
			color: C.red[500],
			tooltip: "Connection failed"
		};
		case "CONNECTION_TIMEOUT": return {
			icon: "exclamation-triangle-filled",
			color: C.red[200],
			tooltip: "Connection timeout"
		};
		default: return {
			icon: "exclamation-circle-filled",
			color: C.neutral[500],
			tooltip: "Not connected"
		};
	}
}, xt = ({ configuration: e, integrationId: t, integrationType: n, label: r }) => {
	let [i, a] = k("CONNECTING"), [o, s] = k(""), [c, u] = k(null), { track: h } = Z(), { icon: g, color: _, tooltip: v } = bt(i), [y, x] = k({}), [C, w] = k(0), [T, E] = k(2e3), [D, N] = k(!1), [te, ne] = k(3), { isInboundOAuth: ie, setIsInboundOAuth: P, hasTriggeredAuthorization: ae, setHasTriggeredAuthorization: oe } = tt(), { baseUrl: F } = e, se = `${F}/auth/connect/${n.toLowerCase()}/${t}`, I = `${F}/auth/status/${n.toLowerCase()}/${t}`, L = i === "CONNECTING", R = (e) => Object.keys(e).length === 0, z = () => {
		N(!1), w(0);
	};
	O(() => {
		let e = localStorage.getItem("authData");
		if (e) {
			let t = JSON.parse(e ?? "{}").access_token;
			x({
				method: "GET",
				headers: {
					"content-type": "application/json",
					authorization: `Bearer ${t}`,
					...yt(F) && vt(t)
				}
			});
		}
	}, [F]), O(() => {
		R(y) || N(!0);
	}, [y]);
	let ce = () => {
		ne(15), fetch(I, { ...y }).then((e) => e.json()).then(({ data: e }) => {
			let { status: r, createdAt: i, createdByName: o } = e;
			switch (r) {
				case "CONNECTING":
					a("CONNECTING");
					break;
				case "CONNECTED":
					if (h("settings:view:oauth:succeeded", {
						widgetId: t,
						widgetType: n
					}), a("CONNECTED"), i && o) {
						let e = new Date(i);
						isNaN(e.getTime()) || u(e), s(o);
					}
					z();
					break;
				case "NOT_CONNECTED":
				case "CONNECTION_FAILED": a(r), z();
			}
		}).catch((e) => {
			console.warn(`Fetching OAuth status failed for ${n} ${t}`, e), a("CONNECTION_FAILED");
		});
	};
	re(() => {
		C >= te ? (a("CONNECTION_TIMEOUT"), z()) : (ce(), w(C + 1));
	}, D ? T : null);
	let B = () => {
		h("settings:view:oauth:started", {
			widgetId: t,
			widgetType: n
		}), fetch(se, { ...y }).then((e) => e.json()).then(({ data: e }) => {
			let { url: t } = e, n = window.innerWidth / 2 - 620 / 2, r = window.innerHeight / 2 - 800 / 2;
			a("CONNECTING"), N(!0), window.open(t, "DixaPartnerOAuth", `toolbar=no,
						location=no,
						status=no,
						menubar=no,
						scrollbars=yes,
						resizable=yes,
						width=620,
						height=800,
						left=${n},
						top=${r}`);
		}).catch((e) => {
			console.warn(`Fetching OAuth connection failed for ${n} ${t}`, e), a("CONNECTION_FAILED");
		});
	};
	return O(() => {
		ie && !ae && !R(y) && (oe(!0), P(!1), B());
	}, [y]), /* @__PURE__ */ M(A, { children: [/* @__PURE__ */ j(p, {
		span: 3,
		children: /* @__PURE__ */ j(d, {
			label: r,
			meta: { warning: "All agents interact with the widget using your access permissions." },
			style: { marginBottom: 20 },
			children: /* @__PURE__ */ M(f, {
				flexDirection: "row",
				alignItems: "baseline",
				gap: "300",
				children: [/* @__PURE__ */ j(l, {
					icon: "key",
					variant: "secondary",
					onClick: B,
					disabled: L,
					style: { marginBottom: 8 },
					children: "Start authorization"
				}), /* @__PURE__ */ j(ee, {
					content: v,
					children: L ? /* @__PURE__ */ j(b, {
						"data-testid": "oauth-button-spinner",
						size: 18
					}) : /* @__PURE__ */ M(f, {
						alignItems: "center",
						gap: "200",
						children: [/* @__PURE__ */ j(m, {
							"data-testid": "oauth-button-status-icon",
							name: g,
							color: _
						}), i === "CONNECTED" && o && c && /* @__PURE__ */ M(S.Paragraph, {
							variant: "4",
							subdued: !0,
							children: [
								"Authorized by ",
								o,
								" at",
								" ",
								je(c).format("DD MMM YYYY @ HH:mm")
							]
						})]
					})
				})]
			})
		})
	}), /* @__PURE__ */ j(p, { span: 3 })] });
}, St = ({ value: e }) => /* @__PURE__ */ j(m, {
	name: e ? "check-circle-filled" : "close-circle-filled",
	color: e ? C.green[500] : C.red[500],
	size: 14,
	"data-testid": `displayAttributeValue-icon-${e ? "true" : "false"}`
}), Ct = ({ value: e }) => /* @__PURE__ */ j(S.Paragraph, {
	variant: "5",
	color: "secondary",
	align: "right",
	children: e.join(", ")
}), wt = ({ value: e }) => /* @__PURE__ */ j(s, {
	variant: "success",
	size: "small",
	children: e
}), Tt = ({ value: e }) => {
	let t = e.replace("days_ago: ", ""), n = t.startsWith("-"), r = t === "0", i = n ? `${t.replace("-", "")} days ago` : `in ${t} days`;
	return /* @__PURE__ */ j(S.Paragraph, {
		variant: "5",
		color: "secondary",
		children: r ? "today" : i
	});
}, Et = ({ value: e }) => /* @__PURE__ */ j(S.Paragraph, {
	variant: "5",
	color: "secondary",
	children: e.format(Le)
}), Q = ({ value: e }) => /* @__PURE__ */ j(s, {
	variant: "info",
	size: "small",
	children: e
}), Dt = (e, t) => {
	if (e == null) return null;
	if (t === "string") return /* @__PURE__ */ j(Q, { value: e.toString() });
	if (Array.isArray(e)) return /* @__PURE__ */ j(Ct, { value: e });
	if (typeof e == "boolean" || e === "true" || e === "false") return /* @__PURE__ */ j(St, { value: e === "true" || e === !0 });
	if (typeof e == "number" || /^\d*\.?\d+$/.test(e)) return /* @__PURE__ */ j(wt, { value: e });
	if (e.startsWith("days_ago: ")) return /* @__PURE__ */ j(Tt, { value: e });
	let n = je(e);
	return n.isValid() ? /* @__PURE__ */ j(Et, { value: n }) : /* @__PURE__ */ j(Q, { value: e });
}, Ot = (e) => {
	let { isCreationMode: t = !1, label: n, helpIcon: r, name: i } = e, [a, o] = k(t);
	if (!a) {
		let e = typeof n == "string" ? n : "";
		return /* @__PURE__ */ j(d, {
			label: n,
			helpIcon: r,
			children: /* @__PURE__ */ M(l, {
				"data-testid": `secret-field-button-${i}`,
				variant: "secondary",
				icon: "pen",
				onClick: () => o(!0),
				children: ["Update ", e]
			})
		});
	}
	return /* @__PURE__ */ j(kt, {
		...e,
		isCreationMode: t,
		onClose: () => o(!1)
	});
}, kt = (e) => {
	let { isCreationMode: t, componentProps: n, onClose: r } = e, i = {
		...n,
		prefix: t ? n?.prefix : {
			type: "button",
			button: {
				icon: "close",
				onClick: r
			}
		}
	};
	return /* @__PURE__ */ j(F, {
		...e,
		componentProps: i,
		shouldUnregister: !0
	});
}, $ = {
	wrapper: "_wrapper_1lmim_1",
	wrapperBox: "_wrapperBox_1lmim_4",
	wrapperBoxErrorBorder: "_wrapperBoxErrorBorder_1lmim_9"
}, At = (e, t) => e !== "" && t !== "" ? window.btoa(`${e}:${t}`) : "", jt = (e) => {
	let { isCreationMode: t = !1, label: n, name: r } = e, [i, a] = k(t);
	if (!i) {
		let e = typeof n == "string" ? n : "";
		return /* @__PURE__ */ j(d, {
			label: n,
			children: /* @__PURE__ */ M(l, {
				"data-testid": `secret-field-button-${r}`,
				variant: "secondary",
				icon: "pen",
				onClick: () => a(!0),
				children: ["Update ", e]
			})
		});
	}
	return /* @__PURE__ */ j(Mt, {
		...e,
		isCreationMode: t,
		onClose: () => a(!1)
	});
}, Mt = (e) => {
	let { name: t, control: n, label: r, rules: i, isCreationMode: a, usernameLabel: o, passwordLabel: s, usernamePlaceholder: c, passwordPlaceholder: l, onClose: p } = e, { field: m, fieldState: h } = te({
		name: t,
		control: n,
		rules: i,
		shouldUnregister: !0
	}), [g, _] = k(""), [v, y] = k(""), b = (e) => {
		_(e), m.onChange(At(e, v));
	}, x = (e) => {
		y(e), m.onChange(At(g, e));
	}, S = !!i?.required;
	return /* @__PURE__ */ j(d, {
		label: r,
		required: S,
		meta: {
			touched: h.isTouched,
			error: h.error?.message
		},
		className: $.wrapper,
		children: /* @__PURE__ */ M(f, {
			gap: "300",
			flexDirection: "column",
			className: se($.wrapperBox, { [$.wrapperBoxErrorBorder]: !!h.error }),
			children: [/* @__PURE__ */ j(u, {
				noAlert: !0,
				required: S,
				label: o,
				placeholder: c,
				input: {
					name: t,
					value: g,
					onChange: (e) => b(e?.target.value ?? ""),
					onBlur: m.onBlur
				},
				...!a && { prefix: {
					type: "button",
					button: {
						icon: "close",
						onClick: p
					}
				} }
			}), /* @__PURE__ */ j(u, {
				noAlert: !0,
				required: S,
				label: s,
				placeholder: l,
				input: {
					name: t,
					value: v,
					onChange: (e) => x(e?.target.value ?? ""),
					onBlur: m.onBlur
				},
				...!a && { prefix: {
					type: "button",
					button: {
						icon: "close",
						onClick: p
					}
				} }
			})]
		})
	});
}, Nt = {
	submit: "Submit",
	delete: "Delete",
	confirmDelete: "Yes",
	cancelDelete: "No"
}, Pt = ({ integrationType: e, integrationId: t, widgetName: n, isCreationMode: r, isSubmitting: i, automationCouplingState: a, onConfirmDelete: o, labels: s, deleteConfirmationBody: c, confirmDeleteVariant: u = "primary" }) => {
	let { track: d } = Z(), [p, m] = k(!1), h = {
		...Nt,
		...s
	}, g = !a || !a.isCoupled;
	return /* @__PURE__ */ M(A, { children: [/* @__PURE__ */ M(f, {
		margin: "300 0 0 0",
		children: [/* @__PURE__ */ j(l, {
			type: "submit",
			isLoading: i,
			disabled: i,
			children: h.submit
		}), !r && /* @__PURE__ */ j(ee, {
			content: "The widget is used in automations",
			disabled: g,
			children: /* @__PURE__ */ j(l, {
				style: { marginLeft: 20 },
				icon: "trash",
				variant: "secondary",
				type: "button",
				onClick: () => {
					t && d("settings:view:delete:requested", {
						widgetId: t,
						widgetType: e
					}), m(!0);
				},
				disabled: !g,
				isLoading: a?.isLoading,
				children: h.delete
			})
		})]
	}), /* @__PURE__ */ j(De, {
		isOpen: p,
		setIsOpen: m,
		confirmVariant: u,
		confirmLabel: h.confirmDelete,
		cancelLabel: h.cancelDelete,
		onCancel: () => {
			t && d("settings:view:delete:canceled", {
				widgetId: t,
				widgetType: e
			});
		},
		onConfirm: o,
		children: /* @__PURE__ */ j(f, { children: c ?? /* @__PURE__ */ M(A, { children: [
			"Are you sure you want to delete the ",
			e,
			" integration \"",
			n,
			"\"?"
		] }) })
	})] });
}, Ft = e`
  query read($conversationId: String!) {
    Storage {
      widgetData(conversation: $conversationId)
    }
  }
`, It = e`
  mutation store($conversationId: String!, $data: Storage_JSONObject) {
    Storage {
      storeWidgetData(conversation: $conversationId, data: $data) {
        data
      }
    }
  }
`;
function Lt(e) {
	let { useQuery: t, useMutation: n } = at(), [r, i] = k(), [a, o] = k(), [s, c] = k(!1), { loading: l, data: u, error: d } = t(Ft, {
		skip: !e,
		variables: { conversationId: e?.toString() }
	}), [f, { loading: p, error: m }] = n(It);
	return O(() => {
		!l && u && i(u?.Storage?.widgetData ?? {});
	}, [u, l]), O(() => d && o(d), [d]), O(() => c(l), [l]), O(() => m && o(m), [m]), O(() => c(p), [p]), {
		data: r,
		loading: s,
		store: async (t, n) => await f({ variables: {
			conversationId: (n ?? e)?.toString(),
			data: t
		} }).then(({ data: e }) => i(e?.Storage?.storeWidgetData?.data ?? {})),
		error: a
	};
}
//#endregion
//#region src/hooks/useWidgetSettingsMutations/useWidgetSettingsMutations.ts
var Rt = ({ integrationId: e, integrationType: t, handleRedirect: r, showNotification: a }) => {
	let { track: o } = Z(), [s, c] = k(!1), [l, u] = k(), [d, f] = k(null), p = E((e) => (t) => {
		u(t), c(!1), a({
			title: "Something went wrong",
			text: `The ${e} of the widget was not successful.`,
			icon: "exclamation-triangle-filled",
			severity: "warning"
		});
	}, [a]), [m] = i(R, { onError: p("creation") }), [h] = i(L, { onError: p("update") }), [g] = i(z, { onError: p("deletion") }), _ = n(), v = E(() => e ? !!_.readQuery({
		query: I,
		variables: { id: e }
	})?.Management?.widgetConfigurations?.[0]?.renderConditions?.length : !1, [_, e]);
	return {
		create: E(async ({ name: e, enabled: n, settings: i, renderConditions: s = [] }) => {
			o("settings:create:submitted", { widgetType: t }), c(!0), u(void 0);
			let { data: l } = await m({ variables: {
				type: t,
				name: e,
				enabled: n,
				settings: i,
				renderConditions: s
			} });
			c(!1);
			let d = l?.Management?.createWidgetConfiguration;
			if (!d) {
				a({
					title: "Something went wrong",
					text: "The creation of the widget was not successful.",
					icon: "exclamation-triangle-filled",
					severity: "warning"
				});
				return;
			}
			Y(o, !0, s, !1), a({
				title: "Creating was successful",
				text: "Creating the widget was successful.",
				icon: "check-circle-filled",
				severity: "success"
			}), r(d.id);
		}, [
			m,
			r,
			t,
			a,
			o
		]),
		update: E(async ({ name: n, enabled: r, settings: i, renderConditions: s }) => {
			if (!e) return;
			o("settings:view:change:submitted", {
				widgetId: e,
				widgetType: t
			});
			let l = v();
			c(!0), u(void 0);
			let { data: d } = await h({ variables: {
				id: e,
				name: n,
				enabled: r,
				settings: i,
				...s !== void 0 && { renderConditions: s }
			} });
			c(!1);
			let p = d?.Management?.updateWidgetConfiguration;
			if (!p) {
				a({
					title: "Something went wrong",
					text: "The update of the widget was not successful.",
					icon: "exclamation-triangle-filled",
					severity: "warning"
				});
				return;
			}
			p.misconfigured ? f(p.misconfigurationCause ?? "The configuration of the integration is not correct. Please check the settings.") : f(null), s && Y(o, !1, s, l), a({
				title: "Updating was successful",
				text: "Updating the widget was successful.",
				icon: "check-circle-filled",
				severity: "success"
			});
		}, [
			e,
			t,
			v,
			a,
			o,
			h
		]),
		remove: E(async () => {
			if (!e) return;
			o("settings:view:delete:confirmed", {
				widgetId: e,
				widgetType: t
			}), c(!0), u(void 0);
			let { data: n } = await g({ variables: { id: e } });
			c(!1), n?.Management?.deleteWidgetConfiguration && (r(), a({
				title: "Deletion was successful",
				text: "The deletion of the widget was successful.",
				icon: "check-circle-filled",
				severity: "success"
			}));
		}, [
			g,
			r,
			e,
			t,
			a,
			o
		]),
		isLoading: s,
		error: l,
		misconfigurationCause: d,
		setMisconfigurationCause: f
	};
};
//#endregion
//#region src/hooks/useWidgetSettingsQuery/useWidgetSettingsQuery.ts
function zt({ integrationId: e, fieldDefinitions: t, form: n, onMisconfigured: r }) {
	let [i, o] = k(!1), [s, c] = k(), { loading: l, error: u, refetch: d } = a(I, {
		variables: { id: e },
		skip: !e,
		onCompleted: (e) => {
			let i = e?.Management?.widgetConfigurations?.[0];
			if (!i) {
				o(!0), c(void 0);
				return;
			}
			o(!1), c(i), n.reset({
				...mt(i.settings ?? [], t),
				enabled: !!i.enabled,
				name: i.name
			}), i.misconfigured && r?.(i.misconfigurationCause ?? "The configuration of the integration is not correct. Please check the settings.");
		}
	});
	return O(() => {
		o(!1), c(void 0);
	}, [e]), {
		isLoading: l,
		error: u,
		isWidgetUnknown: i,
		refetch: d,
		widgetConfiguration: s
	};
}
//#endregion
//#region src/hooks/useRenderConditions/useRenderConditions.ts
function Bt({ integrationId: e, widgetConfiguration: t, renderConditionsEditor: n }) {
	let r = !e, [i, a] = k(r ? [] : null);
	return O(() => {
		a(r ? [] : null);
	}, [e, r]), O(() => {
		t && i === null && a(t.renderConditions ?? []);
	}, [t, i]), {
		renderConditions: i,
		setRenderConditions: a,
		renderConditionsForSubmit: n && i !== null && i !== null ? i : void 0
	};
}
//#endregion
export { St as DisplayAttributeBoolean, Et as DisplayAttributeDate, Tt as DisplayAttributeDaysAgo, wt as DisplayAttributeNumber, Q as DisplayAttributeString, Ct as DisplayAttributeStringArray, Ee as DisplayErrors, X as InboundOAuthContext, De as IntegrationModal, ke as MisconfigurationBanner, xt as OAuthSettings, jt as PartnerHookFormBasicAuth, Ot as PartnerHookFormSecretText, Ae as PartnerSettingsWrapper, it as WidgetContextProvider, Pt as WidgetSettingsFormFooter, Fe as capitalizeFirstCharacter, Ve as countryCodes, nt as createMockInboundOAuthContextOptions, dt as createWidgetConfigurationCreateMock, pt as createWidgetConfigurationDeleteMock, R as createWidgetConfigurationMutation, ut as createWidgetConfigurationQueryMock, ft as createWidgetConfigurationUpdateMock, Pe as deepClone, Le as defaultDateFormat, Oe as defaultMisconfigurationCause, ct as defaultPartnerSettingsConfiguration, st as defaultWidgetContextValue, z as deleteWidgetConfigurationMutation, Dt as displayAttributeValue, ht as formValuesToSettings, et as getConditionType, bt as getConnectionStatusValues, Be as getCountryNameFromCountryCode, vt as getPartnerDevApiHeaders, I as getWidgetConfigurationByIdQuery, _t as handleWidgetSubmit, de as hasDixaHeaderCheckError, fe as hasDownstreamApiAuthorizationError, ye as hasDownstreamApiBadRequestError, _e as hasDownstreamApiConflictError, xe as hasDownstreamApiForbiddenError, he as hasDownstreamApiNotFoundError, pe as hasDownstreamApiPermissionError, me as hasDownstreamApiServiceUnavailableError, Ce as hasDownstreamApiTooManyRequestsError, Te as hasWidgetMisconfiguredError, Ie as humanizeKey, V as isDixaHeaderCheckError, H as isDownstreamApiAuthorizationError, ve as isDownstreamApiBadRequestError, ge as isDownstreamApiConflictError, be as isDownstreamApiForbiddenError, G as isDownstreamApiNotFoundError, U as isDownstreamApiPermissionError, W as isDownstreamApiServiceUnavailableError, Se as isDownstreamApiTooManyRequestsError, yt as isRunningLocalPartnerApi, we as isWidgetMisconfiguredError, le as makeExecuteQuery, B as makeUseLazyQuery, ue as makeUseMutation, ce as makeUseQuery, gt as mapLabels, Ue as parseAccessToken, Re as parseBoolean, ze as parseString, lt as renderPartnerSettings, mt as settingsToFormValues, ot as stubPartnerEventsBusForTests, Y as trackRenderConditionsSaved, L as updateWidgetConfigurationMutation, K as useCopyWithDelay, Lt as useData, tt as useInboundOAuthContext, Bt as useRenderConditions, Z as useTracking, at as useWidgetContext, Rt as useWidgetSettingsMutations, zt as useWidgetSettingsQuery, He as validateApiHostName };
